import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { EVoyageCrewType } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameMode_game_director } from './voyageGameMode_game_director-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageMenuMain } from './voyageMenuMain-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { EVoyageTile } from './voyageTileData'
import { voyageTilemap } from './voyageTilemap-sidecar'

const namespace = 'voyage-game'

const _skipTutorial = false

let _worldInited = false
export function* generator_initWorld() {
  if (_worldInited) {
    return
  }

  while (!voyageSaver.getIsLoaded()) {
    yield 0
  }

  let id = 0

  l.forEach(voyageTilemap.get().parts, (c) => {
    let hide = false
    let killText = false
    if (c.tile3.type === EVoyageTile.CrewSpawn) {
      hide = true
      let cr = voyageCrew.create(EVoyageCrewType.Crew, 0)
      voyageCrew.moveToIJ(cr, c)
    }
    if (c.tile3.type === EVoyageTile.Text) {
      hide = true
    }

    if (c.tile3.type === EVoyageTile.Elevator) {
      killText = true
      voyageTilemap.addGameElevator(c)
      id++
      voyageTilemap.addGameSystem2(c, 'elevator-' + id)
    }

    if (c.tile3.type === EVoyageTile.System) {
      voyageTilemap.addGameSystem(c)
      if (c.text3.startsWith('fp')) {
        killText = true
        hide = true
      }
      if (c.text3.startsWith('me')) {
        console.log('add med sys', c.text3)
      }
    }
    if (c.tile3.type === EVoyageTile.MedPad) {
      killText = true
      console.log('add med pad', c.text3)
      voyageTilemap.addGameSystem(c)
    }

    if (c.tile3.type === EVoyageTile.Test) {
      hide = true
      if (c.text3 === 'fire') {
        hide = true
        killText = true
        let cr = voyageCrew.create(EVoyageCrewType.Fire, -1)
        voyageCrew.moveToIJ(cr, c)
      }

      if (c.text3 === 'alien') {
        hide = true
        killText = true
        let cr = voyageCrew.create(EVoyageCrewType.Alien, 1)
        voyageCrew.moveToIJ(cr, c)
      }

      if (c.text3 === 'breach') {
        hide = true
        killText = true
        let cr = voyageCrew.create(EVoyageCrewType.HullBreach, -1)
        voyageCrew.moveToIJ(cr, c)

        // voyageTilemapPart.setHullBreach(c, true)
      }

      if (c.text3 === 'dead') {
        hide = true
        killText = true

        if (rando.chance(0.5)) {
          let cr = voyageCrew.create(EVoyageCrewType.Crew, 0)
          voyageCrew.moveToIJ(cr, c)
          voyageCrew.hurt(cr, 100, 'Found dead')
        } else {
          let cr = voyageCrew.create(EVoyageCrewType.Alien, 0)
          voyageCrew.moveToIJ(cr, c)
          voyageCrew.hurt(cr, 100, 'Found dead')
        }

        // voyageTilemapPart.setHullBreach(c, true)
      }

      if (c.text3 === 'es-hammerhead') {
        hide = true
        killText = true

        voyageGameStatus_enemyShips.createHammerheadClass()
      }
    }

    if (c.image3 && hide) {
      c.image3.visible = false
    }
    if (c.text && killText) {
      stevieTexts2.kill(c.text)
      c.text = null
    } else {
      if (c.system) {
        console.log('got a system!', c.system.nickname)
        if (c.system.data.abbv && c.text) {
          stevieTexts2.setText(c.text, c.system.data.abbv)
          if (c.system.data.abbv.length === 1) {
            stevieTexts2.moveTo(
              c.text,
              c.text.x + 2 + c.system.data.abbvXAdjust,
              c.text.y + 2,
            )
          }
          if (c.system.data.abbv.length === 2) {
            stevieTexts2.moveTo(
              c.text,
              c.text.x - 6 + c.system.data.abbvXAdjust,
              c.text.y + 2,
            )
          }
        }
      }
    }
  })

  _worldInited = true
}

export function* generator_game(): Generator<number, number, number> {
  console.log(namespace, 'starting game!!')

  voyageMenuMain.setOpen(false)

  yield* generator_initWorld()

  // voyagePicker.selectFirstCrew()

  // if (!_skipTutorial) {
  yield* voyageGameMode_tutorial.generator_tutorial()
  // }

  // console.log('flippo')
  //while (true) {
  yield* voyageGameMode_game_director.generator_director()

  // generalGameLoop()
  //yield 0
  //}
  return 0
}

export function generalGameLoop() {
  // console.log('flippo')
}
